import React, { Component } from 'react';
import request from '../../../lib/requester';
import _, { toNumber } from 'lodash';
import { Link } from 'react-router-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { Loader } from 'react-overlay-loader';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

class ExceptionReport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			start_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
			end_date: new Date(),
			choosen_org: '',
			choosen_status: '',
			lov_branch: [],
			dataTable: [],
			loading: false,
			user: JSON.parse(window.localStorage.getItem('is_user')),
			program_desc: '',
		};
	}

	componentDidMount = async () => {
		if (this.state.user.role_name !== 'CHD-HO') {
			this.dataBranch();
		}
	};

	dataBranch = () => {
		let { user } = this.state;
		let url = '/api/traces_chd/v1/report/branch-list';
		request.getCHD(url, {
			success: function (response) {
				let { data } = response.data;
				let find = _.find(data, function (o) {
					return o.org_id === user.org_id;
				});

				// If not found, then push to LOV
				if (!find) {
					data.push({
						org_id: user.org_id,
						org_initial: user.org_initial,
						org_name: user.org_name,
					});
				}

				this.setState({
					lov_branch: response.data.data || [],
					choosen_org: user.origin === 'HO' ? 'ALL' : user.org_id,
				});
			}.bind(this),
			error: function (e) {
				console.log(e);
			}.bind(this),
		});
	};

	handleStartDate = async (date) => {
		this.setState({ start_date: date });
	};

	handleEndDate = async (date) => {
		this.setState({ end_date: date });
	};

	renderFilter = () => {
		return (
			<div>
				<div className='row'>
					<div className='col-md-12'>
						<div className='card-body pt-1'>
							<div className='row'>
								<div className='col-md-3'>
									<small>
										<strong>From (Claim Date)</strong>
									</small>
									<div className='customDatePickerWidth'>
										<DatePicker
											selected={this.state.start_date}
											dateFormat='d-MMM-yyyy'
											className='form-control form-control-sm'
											popperPlacement='top-end'
											onChange={this.handleStartDate}
										/>
									</div>
								</div>
								<div className='col-md-3'>
									<small>
										<strong>To (Claim Date)</strong>
									</small>
									<div className='customDatePickerWidth'>
										<DatePicker
											selected={this.state.end_date}
											dateFormat='d-MMM-yyyy'
											className='form-control form-control-sm'
											popperPlacement='top-end'
											onChange={this.handleEndDate}
										/>
									</div>
								</div>
								<div className="col-md-6">
                  <small><strong>Program Desc:</strong></small>
                  <input value={this.state.program_desc} onChange={(e) => this.setState({program_desc: e.target.value})} type="text" className="form-control form-control-sm" placeholder="Program Desc" />
                </div>
							</div>
							<div className='row mt-3'>
								<div className='col-md-3'>
									<button
										type='button'
										className='btn btn-primary btn-block'
										onClick={this.handleSearch.bind(this)}>
										<i className='fa fa-search' /> Search
									</button>
								</div>
								<div className='col-md-3'>
									<button
										type='button'
										className='btn btn-success btn-block'
										onClick={this.handleExport.bind(this)}>
										<i className='fa fa-file-excel' /> Export To Excel
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	handleSearch = () => {
		let { choosen_org, user } = this.state;
		let branch = {};
		if (choosen_org !== 'ALL') {
			branch = _.find(this.state.lov_branch, function (o) {
				return o.org_id === choosen_org;
			});
		} else {
			branch.org_name = 'ALL';
		}

		let url = '/api/traces_chd/v1/report/exception';
		let param = {
			startDate: this.state.start_date,
			endDate: this.state.end_date,
			program_desc: this.state.program_desc
		};

		this.setState({ loading: true });
		request.postCHD(url, param, {
			success: function (response) {
				console.log(response.data);
				this.setState({ loading: false, dataTable: response.data.data || [] });
			}.bind(this),
			error: function (e) {
				this.setState({ loading: false });
			}.bind(this),
		});
	};

	renderTable = () => {
		let app = this;
		const data = {
			columns: [
				{
					Header: 'Payment Process No',
					accessor: 'payment_process_no',
					filterable: true,
				},
				{
					Header: 'Claim Number',
					accessor: 'claim_number',
					filterable: true,
				},
				{
					Header: 'No Invoice',
					accessor: 'ap_invoice_no',
					filterable: true,
				},
				{
					Header: 'Tanggal Pembayaran',
					accessor: 'paid_date',
					filterable: true,
				},
				{
					Header: 'PIC Claim',
					accessor: 'email',
					filterable: true,
				},
				{
					Header: 'Cabang',
					accessor: 'branch_code',
					filterable: true,
				},
				{
					Header: 'Nama Relasi',
					accessor: 'customer_name',
					filterable: true,
				},
				{
					Header: 'Pemilik Rekening',
					accessor: 'bank_acc_owner',
					filterable: true,
				},
				{
					Header: 'Period',
					accessor: 'period',
					filterable: true,
				},
				{
					Header: 'Nett Claim',
					accessor: 'nett_claim',
					filterable: true,
				},
				{
					Header: 'PPh',
					accessor: 'pph',
					filterable: true,
				},
				{
					Header: 'PPh Type',
					accessor: 'pph_type',
					filterable: true,
				},
				{
					Header: 'Value Gross Up',
					accessor: 'value_gross_up',
					filterable: false,
				},
				{
					Header: 'Ex Invoice',
					accessor: 'ap_x_invoice_no',
					filterable: true,
				},
				{
					Header: 'Tolakan',
					accessor: 'tolakan',
					filterable: true,
				},
				{
					Header: 'No. IM Program',
					accessor: 'ref_number',
					filterable: true,
				},
				{
					Header: 'Program Description',
					accessor: 'description',
					filterable: true,
				},
				{
					Header: 'Package',
					accessor: 'package',
					filterable: true,
				},
				{
					Header: 'Status Kwitansi',
					accessor: 'status_kwitansi',
					filterable: true,
				},
			],
			rows: this.state.dataTable,
		};
		return (
			<ReactTable
				className='fullWidth'
				data={data.rows}
				columns={data.columns}
				defaultPageSize={10}
				defaultFilterMethod={(filter, row, column) => {
					let columnes = row[filter.id];
					return columnes
						? columnes.toLowerCase().includes(filter.value.toLowerCase())
						: '';
				}}
			/>
		);
	};

	handleExport = () => {
		let { choosen_org } = this.state;
		let branch = _.find(this.state.lov_branch, function (o) {
			return o.org_id === choosen_org;
		});
		let url = '/api/traces_chd/v1/report/exception';
		let param = {
			startDate: this.state.start_date,
			endDate: this.state.end_date,
			program_desc: this.state.program_desc,
			export: true,
		};

		this.setState({ loading: true });
		request.postCHD(url, param, {
			success: function (response) {
				let data = response.data.data;
				this.setState({ loading: false, dataTable: data.data || [] });
				if (data.fullpath) {
					window.open(data.fullpath, '_blank');
					return false;
				}
			}.bind(this),
			error: function (e) {
				this.setState({ loading: false });
			}.bind(this),
		});
	};
	render() {
		return (
			<div>
				<section className='content'>
					<div className='container-fluid'>
						<div className='row ml-1'>
							<div className='col-lg-12 col-sx-12'>
								<form className='form-horizontal'>
									<div className='card card-info'>
										<div className='card-header'>Report Exception</div>
										<div className='card-body'>
											{this.renderFilter()}
											{this.renderTable()}
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</section>
				<Loader fullPage loading={this.state.loading} />
			</div>
		);
	}
}

export default ExceptionReport;
